import { APICore, API_URL, MORTGAGE_URL } from './apiCore';

const api = new APICore();

const createMortgage = (clientId: string, creationReason?: string) => {
    return api.create(`${MORTGAGE_URL}/mortgage`, { clientId, creationReason });
};

const editMortgage = (taxReturnId: string, body: any) => {
    const relativeUrl = `/mortgage/${taxReturnId}`;
    return api.update(`${MORTGAGE_URL}${relativeUrl}`, body);
};

const getMortgageStatuses = () => {
    return api.get(`${MORTGAGE_URL}/mortgage/statuses`);
};

const sendBankEmails = (payload: {
    banks: number[];
    subject: string;
    content: string;
    attachmentFileIds: string[];
    clientId: string;
    mortgageId: string;
}) => {
    return api.create(`${MORTGAGE_URL}/mortgage/bank-email`, payload);
};

const getBankEmails = (clientId: string) => {
    return api.get(`${MORTGAGE_URL}/mortgage/bank-email?clientId=${clientId}`);
};

const getMortgageStatusTrackers = (params: { mortgageId?: string; clientId?: string }) => {
    const url = `${MORTGAGE_URL}/mortgage/status-trackers`;
    return api.get(url, params);
};

export { getMortgageStatuses, createMortgage, editMortgage, sendBankEmails, getBankEmails, getMortgageStatusTrackers };
